import GA from "lib/ga";
import {
    isHighValueLeads,
    isJBLeads,
    isLuxuryWatchSegmentLead,
    isUltraValueLeads,
} from "../helpers/itemHelper";
import { isFakePhone } from "../helpers/ApplicationHelper";
import WorthyApi from "./api/worthyApi";

export default class CalendlyHelper {
    static defaultConsultUrl = process.env.REACT_APP_CALENDLY_AE_URL;

    // Use loadCalendly in the componentDidMount method to load the relevant script ans css
    static loadCalendly() {
        if (
            document.querySelector("#calendlyScript") ||
            document.querySelector("#calendlyStyle")
        )
            return;
        document.querySelector("html").style.height = "initial";
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.setAttribute(
            "src",
            "https://assets.calendly.com/assets/external/widget.js"
        );
        script.setAttribute("id", "calendlyScript");
        const style = document.createElement("link");
        style.setAttribute("rel", "stylesheet");
        style.setAttribute(
            "href",
            "https://calendly.com/assets/external/widget.css"
        );
        style.setAttribute("id", "calendlyStyle");
        head.appendChild(style);
        head.appendChild(script);
    }
    // Use removeCalendly on the componentWillUnmount method to remove unnecessary script and css
    static removeCalendly() {
        const head = document.querySelector("head");
        const script = document.querySelector("#calendlyScript");
        const style = document.querySelector("#calendlyStyle");
        if (style) head.removeChild(style);
        if (script) head.removeChild(script);
    }
    // Use showPopupWidget to popup the calendly widget (will need refactor if another link/eventType is needed)
    static showPopupWidget(page, link, params) {
        const CALENDLY_LINK = link || this.defaultConsultUrl;
        // INFO: left as comment 'https://calendly.com/worthy-tests/15min'
        if (Calendly) {
            Calendly.showPopupWidget(`${CALENDLY_LINK}${params || ""}`);
        } else {
            console.log(
                "Calendly isn't loaded yet, try loadCalendly before calling it"
            );
        }
        return false;
    }

    static intiInlineWidget(link, parentElement) {
        if (Calendly) {
            Calendly.initInlineWidget({
                url: link,
                parentElement: document.getElementById(parentElement),
            });
        } else {
            console.error(
                "Calendly isn't loaded yet, try loadCalendly before calling it"
            );
        }
    }

    static async getCalendlyLinkByValueCategory(item, userId, unverified_registration) {
        let res = null;
        if (unverified_registration) {
            return process.env.REACT_APP_CALENDLY_UNVERIFIED_URL;
        }
        if (userId) {
            res = await WorthyApi.checkIfLuxuryWatchSegmentExists(userId)
        }

        if (res?.data) {
            return process.env.REACT_APP_CALENDLY_LUXURY_WATCHES_URL;
        }
        // INFO: for JB leads
        if (isJBLeads(item)) {
            return process.env.REACT_APP_CALENDLY_JB_URL;

        }
        // check for ultra before HV, since both HV and Ultra can have item.high_value_estimation == true
        if (isUltraValueLeads(item)) {
            return process.env.REACT_APP_CALENDLY_ULTRA_URL;

        }
        // INFO: for High value leads
        if (isHighValueLeads(item)) {
            return process.env.REACT_APP_CALENDLY_HV_URL;

        }
        // INFO: for standard leads
        return process.env.REACT_APP_CALENDLY_AE_URL;
    }

    static calendlyParams(item, ADO) {
        if (!ADO || !ADO.user) {
            return;
        }
        const { first_name, last_name, email, phone, id } = ADO.user;

        // NOTE: Parameter 'a1' refer to the first field on the Calendly form (we defined it as user's phone number). make sure fields order align with the url parameters.
        // For more info about Calendly URL parameters: https://help.calendly.com/hc/en-us/articles/226766767-Pre-populate-invitee-information-on-the-scheduling-page#h_0f5dfae8-723f-4ba2-b96e-26b57b4b51fc
        if (isJBLeads(item)) {
            return `?name=${first_name} ${last_name || ""}&email=${email}${
                phone && !isFakePhone(phone) ? `&a1=1${phone}` : ""
            }
            &utm_source=${id}&utm_campaign=${
                item?.bundle?.id
            }&utm_term=Jewelry Box`;
        }

        if (isHighValueLeads(item)) {
            return `?name=${first_name} ${last_name || ""}&email=${email}${
                phone && !isFakePhone(phone) ? `&a1=1${phone}` : ""
            }
            &utm_source=${id}&utm_campaign=${item.id}&utm_term=High Value`;
        }

        return `?name=${first_name} ${last_name || ""}&email=${email}${
            phone && !isFakePhone(phone) ? `&a1=1${phone}` : ""
        }&utm_source=${id}&utm_campaign=${item.id}`;
    }
}
